/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/FilterAction/Action/Content"
  
}) {
let settingsSelectedAppointmentTemplatesValueData = fromData.useDataFormat({ viewPath,
context: 'settings',
path: 'selected_appointment_templates',
format: fromHelpers.getText,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 weight="medium"
 size="small"
 color={dtColorsNeutral900}
 data="settings.selected_appointment_templates"
 format="helpers.js getText"
 text={settingsSelectedAppointmentTemplatesValueData}
/>
{children}
</React.Fragment>)
}